$(document).ready(function () {

  function checkStickyHeader() {
      let isSticky = $('.cl-header-wrapper--sticky-header').hasClass('show');
      let isMobileHeader = window.innerWidth < 768 && $('.cl-header--main-wrapper').hasClass('show');

      if (isSticky || isMobileHeader) {
          $('aside.facets-wrapper').addClass('scroll-top');
      } else {
          $('aside.facets-wrapper').removeClass('scroll-top');
      }
  }
  $(window).on('scroll resize', checkStickyHeader);

  // ----------- Collection Page Grid Filters with sessionStorage -----------

  function updateGrid(selected, store = true) {
      $('.gridTabs span').removeClass('active');
      selected.addClass('active');

      const isGridTwo = selected.hasClass('gridTwo');

      // Save user preference to sessionStorage
      if (store) {
          sessionStorage.setItem('gridLayout', isGridTwo ? 'two' : 'four');
      }

      if ($(window).width() < 768) {
          $('.collection .grid').each(function () {
              this.style.setProperty('grid-template-columns', isGridTwo ? 'repeat(1,1fr)' : 'repeat(2,1fr)', 'important');
          });
      } else {
          $('.collection .grid').each(function () {
              this.style.setProperty('grid-template-columns', isGridTwo ? 'repeat(2,1fr)' : 'repeat(4,1fr)');
          });
      }
  }

  $('.gridTabs span').on('click', function () {
      updateGrid($(this));
  });

  $(window).on('resize', function () {
      const active = $('.gridTabs span.active');
      if (active.length) updateGrid(active, false); // don't overwrite stored value
      initFilterAccordion();
      handleFacetsMinHeight();
  });

  // ---- Load saved layout from sessionStorage (if exists) ----
  $(document).ready(function () {
      const savedLayout = sessionStorage.getItem('gridLayout');

      if (savedLayout === 'two') {
          $('.gridTabs span.gridTwo').trigger('click');
      } else {
          $('.gridTabs span.gridFour').trigger('click');
      }
  });

  // ----------- End Collection Page Grid Filters -----------


  // ----------- Collection Page Filters Popup Open/Close Script -----------
  function initFilterAccordion() {
      $('.filterPopup .filter-group h3.filter-title').off('click');
      $('.filterPopup .filterBox h3').off('click');

      if ($(window).width() <= 767) {
          $('.filterPopup .filter-group').not('.filter-group-tags').each(function () {
              $(this).find('.clFilterOptions,.filter-options').slideDown();
              $(this).find('h3,h3.filter-title').addClass('rotated');
          });

          $('.filterPopup .filter-group h3.filter-title').on('click', function () {
              $(this).siblings('.filter-options').stop(true, true).slideToggle('fast');
              $(this).toggleClass('rotated');
          });

          $('.filterPopup .filterBox h3').on('click', function () {
              $(this).siblings('.clFilterOptions').stop(true, true).slideToggle('fast');
              $(this).toggleClass('rotated');
          });

      } else {
          $('.filterPopup .filter-group .clFilterOptions,.filterPopup .filter-group .filter-options').show();
          $('.filterPopup .filter-group h3,h3.filter-title').removeClass('rotated');
      }
  }

  initFilterAccordion();

  if ($(window).width() <= 767) {
      $('details.mobile-facets__disclosure').on('click', function () {
          $(this).closest('aside').addClass('active');
          $(this).closest('aside').find('.facets-container').addClass('active');
          $('.filterPopup,.cl-popup--drawer-overlay').addClass('active');
          $('header').css('z-index', '8');
          $('.cl-announcement--bar').css('z-index', '-1');
          $('aside#main-collection-filters').css('z-index', '9');
          $('.cl-popup--drawer-overlay').css('z-index', '9');
        //   $('body').css('overflow', 'hidden');
        const scrollY = window.scrollY;
        $('body').css({
        position: 'fixed',
        top: `-${scrollY}px`,
        width: '100%'
        });

      });

      $('.filterPopup span.crossBtn,.filterPopup .filterFooter span.applyBtn').on('click', function () {
          $(this).closest('aside').removeClass('active');
          $(this).closest('aside').find('.facets-container').removeClass('active');
          $('.filterPopup,.cl-popup--drawer-overlay').removeClass('active');
          $('header').css('z-index', '');
          $('.cl-announcement--bar').css('z-index', '');
          $('.cl-popup--drawer-overlay').css('z-index', '');
          $('aside#main-collection-filters').css('z-index', '');
        //   $('body').css('overflow', '');
        const scrollY = $('body').css('top');
        $('body').css({ position: '', top: '', width: '' });
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      });

      $('.cl-popup--drawer-overlay').on('click', function () {
          $('aside').removeClass('active');
          $('aside').find('.facets-container').removeClass('active');
          $(this).removeClass('active');
          $('.filterPopup').removeClass('active');
          $('aside#main-collection-filters').css('z-index', '');
          $('.cl-popup--drawer-overlay').css('z-index', '9');
          $('body').css('overflow', '');
      });

  } else {
      $('details.mobile-facets__disclosure').on('click', function () {
          $(this).closest('aside').addClass('active');
          $(this).closest('aside').find('.facets-container').addClass('active');
          $('.filterPopup').addClass('active');
      });

      $('.filterPopup span.crossBtn,.filterPopup .filterFooter span.applyBtn').on('click', function () {
          $('.filterPopup').removeClass('active');
          $(this).closest('aside').removeClass('active');
          $(this).closest('aside').find('.facets-container').removeClass('active');
      });
  }

  // ----------- End Collection Page Filters Popup Open/Close Script -----------

  // ----------- Collection Page Filters Apply Script (AJAX Based) -----------

  function updateIndividualFilterCounts() {
      $('.clFilter .filterBox').each(function () {
          let count = $(this).find('input[type="checkbox"]:checked').length;

          // Special handling for Heel Height filter
          if ($(this).hasClass('option_Heel')) {
              const checkedInputs = $(this).find('input[type="checkbox"]:checked');
              const ranges = [{ min: 0, max: 30 }, { min: 30, max: 55 }, { min: 55, max: 70 }, { min: 70, max: 100 }, { min: 100, max: 1000 }];
              let uniqueGroups = new Set();

              checkedInputs.each(function () {
                  const val = parseInt($(this).val().replace(' mm', ''));
                  const range = ranges.find(r => val >= r.min && val < r.max);
                  if (range) {
                      uniqueGroups.add(`${range.min}-${range.max}`);
                  }
              });

              count = uniqueGroups.size; // Only count unique groups
          }

          $(this).find('h3 > span > .count').text(count ? `(${count})` : '');
      });
  }

  // Update individual filter counts when any checkbox changes
  $(document).on('change', '.clFilter .filterBox input[type="checkbox"]', function () {
      updateIndividualFilterCounts();
  });

  // Update individual filter counts when tag filters change
  $(document).on('change', 'input[name="filter_tag"]', function () {
      updateIndividualFilterCounts();
  });

  function initAjaxFilters() {
      const $form = $('.clFilter');
      const $appliedFilters = $('.appliedFilters');
      const $filterCount = $('.filterPopup .filterFooter span.applyBtn span');

      if (!$form.length || !$appliedFilters.length || !$filterCount.length) return;

      removeDuplicateHeelHeights();
      function removeDuplicateHeelHeights() {
          let seen = {};
          $('.filterBox.option_Heel .clFilterOptions label .label').each(function () {
              let txt = $(this).text().trim().toLowerCase();
              if (seen[txt]) {
                  $(this).closest('label').css('display', 'none');
              } else {
                  seen[txt] = true;
              }
          });
      }

      // Sync tag filters with URL on load
      const params = new URLSearchParams(window.location.search);
      const tags = params.getAll('constraint').length ? params.getAll('constraint') : params.getAll('filter.p.tag');
      $('input[name="filter_tag"]').each(function () {
          const $this = $(this);
          const isChecked = tags.includes($this.val());
          $this.prop('checked', isChecked);
          $this.closest('label').toggleClass('active', isChecked);
      });

      // Check if filters already applied, open popup
      const checkedInputs = $form.find("input[type='checkbox']:checked");
      const checkedTagInputs = $('input[name="filter_tag"]:checked');
      // if(checkedInputs.length || checkedTagInputs.length){
      //   $('.filterPopup,.cl-popup--overlay').addClass('active');
      //   $('aside.facets-wrapper').addClass('active');
      // }

      // Mark already checked filters as active and add to applied filters container
      checkedInputs.each(function () {
          const $label = $(this).closest('label');
          if ($label.length) {
              $label.addClass('active');
              addAppliedFilter($(this).attr('name'), $(this).val(), $label.text().trim());
          }
      });

      // Add checked tag filters to applied filters on load
      checkedTagInputs.each(function () {
          const $label = $(this).closest('label');
          if ($label.length) {
              $label.addClass('active');
              addAppliedFilter($(this).attr('name'), $(this).val(), $label.text().trim());
          }
      });

      updateFilterCount();
      updateIndividualFilterCounts();
      handleFacetsMinHeight(); // Call on page load to handle reload case

      // Filter change event (checkboxes & range inputs)
      $form.on('change', 'input[type="checkbox"],input[type="range"]', function () {
          ajaxFilter();
      });

      $form.on('change', 'input[type="checkbox"]', function () {
          $(this).closest('label').toggleClass('active', $(this).is(':checked'));
      });

      // Tag filter change event
      $('input[name="filter_tag"]').on('change', function () {
          $(this).closest('label').toggleClass('active', $(this).is(':checked'));
          ajaxFilter();
      });

      // Updated remove filter handler
      $appliedFilters.on('click', '.remove-filter', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const $removeBtn = $(this);
          const name = $removeBtn.data('name');
          const value = $removeBtn.data('value');
          const $filterElement = $removeBtn.closest('.applied-filter');
          const filterText = $filterElement.text().replace('×', '').trim();

          console.log('Removing filter:', { name, value, filterText }); // Debug log

          // 1. HANDLE MATERIAL FILTERS
          if (filterText.toLowerCase().includes('material') ||
              (name && name.toLowerCase().includes('material'))) {

              // Try to find matching material checkbox
              let $materialInput = $('input[name*="material"]').filter(function () {
                  return $(this).val() === value ||
                      $(this).closest('label').text().trim().includes(filterText);
              });

              // If not found by exact match, try partial match
              if ($materialInput.length === 0) {
                  $('input[name*="material"]').each(function () {
                      if ($(this).val().toLowerCase().includes(value.toLowerCase()) ||
                          $(this).closest('label').text().toLowerCase().includes(filterText.toLowerCase())) {
                          $materialInput = $(this);
                          return false; // break loop
                      }
                  });
              }

              // Uncheck if found
              if ($materialInput.length) {
                  $materialInput.prop('checked', false);
                  $materialInput.closest('label').removeClass('active');
                  console.log('Successfully removed material filter');
              }
          }

          // 2. HANDLE HEEL HEIGHT FILTERS
          else if (value === "Flat shoe" || value === "range-0-30") {
              // Uncheck all flat shoe checkboxes (0-30mm)
              $('.filterBox.option_Heel input[type="checkbox"]').each(function () {
                  const val = parseInt($(this).val().replace(' mm', '')) || 0;
                  if (val >= 0 && val < 30) {
                      $(this).prop('checked', false);
                      $(this).closest('label').removeClass('active');
                  }
              });
          }
          else if (name.includes('heel') && value.startsWith('range-')) {
              const [_, min, max] = value.split('-');
              $('.filterBox.option_Heel input[type="checkbox"]').each(function () {
                  const val = parseInt($(this).val().replace(' mm', '')) || 0;
                  if (val >= parseInt(min) && val < parseInt(max)) {
                      $(this).prop('checked', false);
                      $(this).closest('label').removeClass('active');
                  }
              });
          }

          // 3. HANDLE TAG FILTERS
          else if (name === 'filter_tag' || name === 'filter.p.tag') {
              $(`input[name="filter_tag"][value="${value}"], 
     input[name="filter.p.tag"][value="${value}"]`)
                  .prop('checked', false)
                  .closest('label')
                  .removeClass('active');
          }

          // 4. HANDLE ALL OTHER FILTERS
          else {
              // First try exact match
              let $input = $(`input[name="${name}"][value="${value}"]`);

              // If not found, try partial match
              if ($input.length === 0) {
                  $(`input[name="${name}"]`).each(function () {
                      if ($(this).val() === value ||
                          $(this).closest('label').text().includes(filterText)) {
                          $input = $(this);
                          return false; // break loop
                      }
                  });
              }

              if ($input.length) {
                  $input.prop('checked', false);
                  $input.closest('label').removeClass('active');
              }
          }

          // Remove the filter element from UI
          $filterElement.remove();

          // Update counts and refresh results
          updateIndividualFilterCounts();
          ajaxFilter();
      });

      $(document).on('change', '.filterBox.option_Heel input[type="checkbox"]', function () {
          const clickedVal = parseInt($(this).val().replace(' mm', '')) || 0;
          const isChecked = $(this).is(':checked');

          // Define ranges with clear boundaries
          const ranges = [
              { min: 0, max: 29.999, name: 'Flats (0-30mm / 0-1.2 inches)', group: 'range-0-30' },
              { min: 30, max: 54.999, name: 'Low Heels (30-55mm / 1.2-2.2 inches)', group: 'range-30-55' },
              { min: 55, max: 69.999, name: 'Medium Heels (55-70mm / 2.2-2.7 inches)', group: 'range-55-70' },
              { min: 70, max: 99.999, name: 'High Heels (70-100mm / 2.7-3.9 inches)', group: 'range-70-100' },
              { min: 100, max: 1000, name: 'Sky High (From 100mm / 3.9 inches)', group: 'range-100-1000' }
          ];

          // Find which range contains the clicked value
          const matchedRange = ranges.find(r => clickedVal >= r.min && clickedVal <= r.max);
          if (!matchedRange) return;

          // First remove any existing heel height filters
          $('.appliedFilters .applied-filter[data-group]').remove();

          // Update checkboxes in this range
          $('.filterBox.option_Heel input[type="checkbox"]').each(function () {
              const val = parseInt($(this).val().replace(' mm', '')) || 0;
              if (val >= matchedRange.min && val <= matchedRange.max) {
                  $(this).prop('checked', isChecked).closest('label').toggleClass('active', isChecked);
              }
          });
          updateIndividualFilterCounts();
          ajaxFilter();
      });

      function addAppliedFilter(name, value, label) {
          // First, check if this exact filter already exists
          const exactFilterExists = $('.appliedFilters .applied-filter').filter(function () {
              return $(this).data('name') === name && $(this).data('value') === value;
          }).length > 0;

          if (exactFilterExists) return; // Skip if already exists

          // Special handling for Heel Height filter
          if (name.includes('heel') || name.includes('Heel')) {
              const val = parseInt(value.replace(' mm', '')) || 0;
              let rangeLabel = '', rangeId = '';

              // Define ranges
              if (val >= 0 && val < 30) {
                  rangeLabel = 'Flats (0-30mm / 0-1.2 inches)';
                  rangeId = 'range-0-30';
              } else if (val >= 30 && val < 55) {
                  rangeLabel = 'Low Heels (30-55mm / 1.2-2.2 inches)';
                  rangeId = 'range-30-55';
              } else if (val >= 55 && val < 70) {
                  rangeLabel = 'Medium Heels (55-70mm / 2.2-2.7 inches)';
                  rangeId = 'range-55-70';
              } else if (val >= 70 && val < 100) {
                  rangeLabel = 'High Heels (70-100mm / 2.7-3.9 inches)';
                  rangeId = 'range-70-100';
              } else if (val >= 100) {
                  rangeLabel = 'Sky High Heels (From 100mm / 3.9 inches)';
                  rangeId = 'range-100-1000';
              }

              // Check if this range group already exists
              if (rangeId && !$('.appliedFilters .applied-filter[data-group="' + rangeId + '"]').length) {
                  $('.appliedFilters').append(`<span class="applied-filter" data-group="${rangeId}">${rangeLabel} <button class="remove-filter" data-name="${name}" data-value="${rangeId}">&times;</button></span>`);
              }
              return; // Always return after handling heel height
          }

          // Default handling for other filters
          $('.appliedFilters').append(`<span class="applied-filter" data-name="${name}" data-value="${value}">${label} <button class="remove-filter" data-name="${name}" data-value="${value}">&times;</button></span>`);
      }

      function updateFilterCount() {
          let normalFilters = $('.clFilter input[type="checkbox"]:checked').length;
          const tagFilters = $('input[name="filter_tag"]:checked').length;

          // Heel Height special logic
          const heelChecked = $('.filterBox.option_Heel input[type="checkbox"]:checked');
          const ranges = [
              { min: 0, max: 30 },
              { min: 30, max: 55 },
              { min: 55, max: 70 },
              { min: 70, max: 100 },
              { min: 100, max: 1000 }
          ];
          let heelGroups = new Set();

          heelChecked.each(function () {
              const val = parseInt($(this).val().replace(' mm', ''));
              const range = ranges.find(r => val >= r.min && val < r.max);
              if (range) {
                  heelGroups.add(`${range.min}-${range.max}`);
              }
          });

          normalFilters -= heelChecked.length; // Remove actual count
          normalFilters += heelGroups.size;    // Add grouped count (should be 1 usually)

          const count = normalFilters + tagFilters;
          const text = count ? `(${count})` : '';
          $('.filterPopup .filterFooter span.applyBtn span').text(text);
          $('#filterCount').text(text);

          if ($(window).width() <= 767) {
              $('.filterPopup .filterFooter').css('display', count ? 'block' : 'none');
          } else {
              $('.filterPopup .filterFooter').css('display', 'block');
          }
      }


      function handleFacetsMinHeight() {
          const isMobile = $(window).width() <= 767;
          const normalFilters = $('.clFilter input[type="checkbox"]:checked').length;
          const tagFilters = $('input[name="filter_tag"]:checked').length;
          const hasFilter = normalFilters + tagFilters > 0;

          if (isMobile && hasFilter) {
              $('aside.facets-wrapper').css('min-height', '110px');
              $('aside#main-collection-filters .appliedFilters-wrapper').css('top', '65px');
          } else {
              $('aside.facets-wrapper').css('min-height', '');
              $('aside#main-collection-filters .appliedFilters-wrapper').css('top', '');
          }
      }

      function ajaxFilter() {
          const url = new URL(window.location.href);
          const params = url.searchParams;
          const inputs = $form.find('input[type="checkbox"],input[type="range"]');
          const names = new Set();

          inputs.each(function () { names.add($(this).attr('name')) });
          names.forEach(name => params.delete(name));
          params.delete('constraint');
          params.delete('filter.p.tag');

          // 👇 Ye do line add kar
          params.delete('page');
          params.set('page', '1');

          $appliedFilters.empty();

          $form.find('input[type="checkbox"]:checked').each(function () {
              params.append($(this).attr('name'), $(this).val());
              const $label = $(this).closest('label');
              if ($label.length) {
                  $label.addClass('active');
                  addAppliedFilter($(this).attr('name'), $(this).val(), $label.text().trim());
              }
          });

          // Handle tag filters with AND logic (products must have ALL selected tags)
          const selectedTags = [];
          $('input[name="filter_tag"]:checked').each(function () {
              selectedTags.push($(this).val());
              const $label = $(this).closest('label');
              if ($label.length) {
                  $label.addClass('active');
                  addAppliedFilter($(this).attr('name'), $(this).val(), $label.text().trim());
              }
          });

          // For AND logic, combine tags with + (Shopify AND operator)
          if (selectedTags.length > 0) {
              if (selectedTags.length === 1) {
                  // Single tag - use normal constraint
                  params.append('constraint', selectedTags[0]);
              } else {
                  // Multiple tags - combine with + for AND logic
                  params.append('constraint', selectedTags.join('+'));
              }
          }

          $form.find('input[type="range"]').each(function () {
              if ($(this).val()) params.set($(this).attr('name'), $(this).val());
          });

          updateFilterCount();
          const newUrl = url.pathname + '?' + params.toString();
          updateUrlAndFetch(newUrl);
          handleFacetsMinHeight();
      }

      // Function to clear all filters
      function clearAllFilters() {
          // Uncheck all filter checkboxes
          $('.clFilter input[type="checkbox"]').prop('checked', false).closest('label').removeClass('active');

          // Uncheck all tag filters
          $('input[name="filter_tag"]').prop('checked', false).closest('label').removeClass('active');

          // Clear applied filters
          $('.appliedFilters').empty();

          // Reset URL to collection base URL without any filters
          const baseUrl = window.location.pathname;
          window.history.pushState({}, '', baseUrl);

          // Reload the page to show all products
          location.reload();
      }

      // Push URL & load collection grid via AJAX with dynamic filter updates
      function updateUrlAndFetch(newUrl) {
          window.history.pushState({}, '', newUrl);
          $('.collection .grid').addClass('loading');

          $.ajax({
              url: newUrl,
              dataType: 'html',
              success: function (data) {
                  const $html = $(data);

                  // Check if there are any products
                  const $newGrid = $html.find('.collection .grid');
                  const $products = $newGrid.find('.customPrdBox, .product-item, .grid-item, .product');

                  if ($products.length === 0) {

                      let baseUrl = window.location.pathname.replace(/\/(filter.*|sort.*)/g, '').split('?')[0]
                      let link = window.location.pathname.includes('/ar')
                          ? baseUrl.includes('/ar/collections') ? baseUrl : baseUrl.replace('/collections', '/ar/collections')
                          : baseUrl

                      $('.collection .grid').html(`
            <div class="product-grid-container" id="ProductGridContainer">
              <div class="collection collection--empty custom-container" id="product-grid" data-id="template--19752560197855__product-grid">
                <div class="loading-overlay gradient"></div>
                <div class="title-wrapper center">
                  <h2 class="title title--primary">
                    No products found<br>
                    Use fewer filters or <a class="underlined-link link" href="${link}">remove all</a>
                  </h2>
                </div>
              </div>
            </div>
          `)

                      // Update product count to show 0
                      $('aside h2.product-count__text').html('0 products');
                  } else {
                      // Products found - update normally
                      $('.collection .grid').html($newGrid.html());
                      $('aside h2.product-count__text').html($html.find('aside h2.product-count__text').html());
                  }

                  // Update pagination
                  const $newPagination = $html.find('.pagination-wrapper');
                  if ($newPagination.length && $newPagination.find('a').length && $products.length > 0) {
                      $('.pagination-wrapper').html($newPagination.html()).show();
                  } else {
                      $('.pagination-wrapper').hide();
                  }

                  // Update available filters (only show relevant ones)
                  const $newFilters = $html.find('.clFilter');
                  if ($newFilters.length) {
                      // Replace each filter group with the updated one
                      $('.clFilter .filterBox').each(function () {
                          const filterName = $(this).data('filter-name') || $(this).find('h3').text().trim();
                          const $newFilter = $newFilters.find(`.filterBox:contains('${filterName}')`).first();
                          if ($newFilter.length) {
                              $(this).replaceWith($newFilter.clone());
                          }
                      });

                      // Reinitialize the filter accordion
                      initFilterAccordion();

                      // Reapply checked states from URL
                      const params = new URLSearchParams(window.location.search);
                      $('.clFilter input[type="checkbox"]').each(function () {
                          const name = $(this).attr('name');
                          const value = $(this).val();
                          const isChecked = params.getAll(name).includes(value);
                          $(this).prop('checked', isChecked);
                          $(this).closest('label').toggleClass('active', isChecked);
                      });

                      // Reapply tag filter states (handle both single and combined tags)
                      const constraintParams = params.getAll('constraint');
                      $('input[name="filter_tag"]').each(function () {
                          const tagValue = $(this).val();
                          let isChecked = false;

                          // Check if tag exists in any constraint parameter
                          constraintParams.forEach(constraint => {
                              if (constraint === tagValue || constraint.includes(tagValue)) {
                                  isChecked = true;
                              }
                          });

                          $(this).prop('checked', isChecked);
                          $(this).closest('label').toggleClass('active', isChecked);
                      });

                      // Update counts
                      updateIndividualFilterCounts();
                  }

                  $('.collection .grid').removeClass('loading');
                  removeDuplicateHeelHeights();
              },
              error: function (xhr, status, error) {
                  console.error("AJAX Error:", status, error);
                  $('.collection .grid').removeClass('loading');
              }
          });
      }
  }

  function initSortAjax() {
      const $form = $('.clFilter');

      $('input[name="sort_by"]').on('change', function () {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', $(this).val());

          // Add checked checkboxes to URL
          $form.find('input[type="checkbox"]:checked').each(function () {
              url.searchParams.append($(this).attr('name'), $(this).val());
          });

          // Add range inputs if any
          $form.find('input[type="range"]').each(function () {
              if ($(this).val()) url.searchParams.set($(this).attr('name'), $(this).val());
          });

          // Add selected tag filters to URL
          $('input[name="filter_tag"]:checked').each(function () {
              url.searchParams.append('constraint', $(this).val());
          });

          window.history.pushState({}, '', url.toString());

          $('.ajax-loader').show();  // ✅ Show loader

          $.ajax({
              url: url.toString(),
              dataType: 'html',
              success: function (data) {
                  const $html = $(data);
                  $('.collection .grid').html($html.find('.collection .grid').html());

                  const $newPagination = $html.find('.pagination-wrapper');
                  if ($newPagination.length && $newPagination.find('a').length) {
                      $('.pagination-wrapper').html($newPagination.html()).show();
                  } else {
                      $('.pagination-wrapper').hide();
                  }

                  $('.ajax-loader').hide(); // ✅ Hide loader
              },
              error: function (xhr, status, error) {
                  console.error("AJAX Error:", status, error);
                  $('.ajax-loader').hide(); // ✅ Hide loader on error too
              }
          });
      });
  }
  initAjaxFilters();
  initSortAjax();
  // ----------- End Collection Page Filters Apply Script -----------

  // Collection Grid Slider Script

//   $(document).on('click', '.customPrdBox .imageWrapper .iconWrapper svg', function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       let $box = $(this).closest('.customPrdBox');
//       let $imageBox = $box.find('.imageWrapper .imageBox');
//       let $wraps = $box.find('.imageWrapper .imageWrap');
//       let width = $wraps.eq(0).outerWidth();
//       let total = $wraps.length;

//       let current = $box.data('slide') || 0;

//       if ($(this).is(':last-child')) {
//           current = (current + 1) % total;
//       } else {
//           current = (current - 1 + total) % total;
//       }

//       $imageBox.scrollLeft(current * width);
//       $box.data('slide', current);
//   });
$(document).on('click', '.customPrdBox .imageWrapper .iconWrapper svg', function (e) {
    e.preventDefault();
    e.stopPropagation();

    let $box = $(this).closest('.customPrdBox');
    let $imageBox = $box.find('.imageWrapper .imageBox');
    let $wraps = $box.find('.imageWrapper .imageWrap');
    let width = $wraps.eq(0).outerWidth();
    let total = $wraps.length;

    // Check if RTL
    let isRTL = $box.css('direction') === 'rtl' || $('html').attr('dir') === 'rtl';

    let current = $box.data('slide') || 0;

    if ($(this).is(':last-child')) {
        // Next button
        current = (current + 1) % total;
    } else {
        // Previous button
        current = (current - 1 + total) % total;
    }

    // RTL ke liye corrected scrollLeft calculation
    if (isRTL) {
        // RTL mein scroll direction ulti hoti hai
        // Maximum scroll position calculate karein
        let maxScroll = $imageBox[0].scrollWidth - $imageBox[0].clientWidth;
        let scrollPosition = current * width;
        
        // RTL mein scrollLeft negative value mein kaam karta hai
        $imageBox.scrollLeft(-scrollPosition);
    } else {
        // LTR (normal)
        $imageBox.scrollLeft(current * width);
    }

    $box.data('slide', current);
    
    // Debugging ke liye console log
    console.log('Current slide:', current, 'RTL:', isRTL, 'Scroll Left:', $imageBox.scrollLeft());
});
  // ----------- End Collection Grid Slider Script -----------
});